import { gql } from '@apollo/client';
import {
  GetDailymotionUploadUrlQuery,
  GetDailymotionUploadUrlQueryVariables,
} from '../../__generated__/queries-web';
import { useGetter } from '../useGetter';

const GET_DAILYMOTION_UPLOAD_URL = gql`
  query getDailymotionUploadURL($brandKey: BrandKey!) {
    dailymotionUploadURL(brandKey: $brandKey) {
      uploadUrl
      progressUrl
    }
  }
`;

export const useDailymotionUploadURLGetter = () =>
  useGetter<
    GetDailymotionUploadUrlQuery,
    GetDailymotionUploadUrlQueryVariables
  >(GET_DAILYMOTION_UPLOAD_URL);
